export default __webpack_public_path__ + "img/b23855665e6d5e3e31b99ef838066e11.png";